// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","schoolHistoryRow":"_3ceThGg56NKXPB7CNy_WGT","schoolHistoryColumn":"_3vJ6OVMm1oQijil5ycwQNB","schoolHistoryCurrentStudent":"xenMrore1seTNwVzIzGr1"};